/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InviteBindingDialog.vue?vue&type=template&id=4a962d6b&scoped=true"
import script from "./InviteBindingDialog.vue?vue&type=script&lang=js"
export * from "./InviteBindingDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteBindingDialog.vue?vue&type=style&index=0&id=4a962d6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a962d6b",
  null
  
)

export default component.exports